var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconSuccessSolid = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.504 10.69A7.031 7.031 0 1 1 14.496 5.31 7.031 7.031 0 0 1 1.504 10.69m10.638-5.612a.5.5 0 0 0-.784-.62l-4.902 6.201-.006.008a.156.156 0 0 1-.253-.008l-.007-.01-1.531-2.173a.5.5 0 1 0-.818.576l1.529 2.17a1.155 1.155 0 0 0 1.873.054z",
    clipRule: "evenodd"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.504 10.69A7.031 7.031 0 1 1 14.496 5.31 7.031 7.031 0 0 1 1.504 10.69m10.638-5.612a.5.5 0 0 0-.784-.62l-4.902 6.201-.006.008a.156.156 0 0 1-.253-.008l-.007-.01-1.531-2.173a.5.5 0 1 0-.818.576l1.529 2.17a1.155 1.155 0 0 0 1.873.054z",
    clipRule: "evenodd"
  })));
});
export default SvgIconSuccessSolid;
export const raw = __webpack_public_path__ + "static/media/IconSuccessSolid.c4cc910fc2055b5a2aee33065f34a575.svg";